import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const selectLegalsDomain = state => state.legalsReducer || initialState;

export const getIsLegalsLoadingSelector = () =>
	createSelector(selectLegalsDomain, ({ isLegalsLoading }) => isLegalsLoading);

export const getIsDownloadLoadingSelector = () =>
	createSelector(selectLegalsDomain, ({ isDownloadLoading }) => isDownloadLoading);

export const getLegalsSelector = () => createSelector(selectLegalsDomain, ({ legals }) => legals);

export const getLegalsSearchValueSelector = () =>
	createSelector(selectLegalsDomain, ({ legalsSearchValue }) => legalsSearchValue);

export const getRawPaginationSelector = () => createSelector(selectLegalsDomain, ({ pagination }) => pagination);

export const getPaginationSelector = () =>
	createSelector(selectLegalsDomain, ({ pagination }) => {
		if (!pagination || pagination?.total === 0) {
			return null;
		}

		return {
			currentPage: pagination.current_page,
			totalPages: pagination.last_page,
			perPage: pagination.per_page,
			total: pagination.total,
			from: pagination.current_page * pagination.per_page - (pagination.per_page - 1),
			to:
				pagination.current_page === pagination.last_page
					? pagination.total
					: pagination.current_page * pagination.per_page,
			isNextItem: true,
			isPrevItem: true,
			isLastItem: false,
			isFirstItem: false,
		};
	});
